<!-- Header -->
<h3 mat-dialog-title translate>
    Course Description
</h3>

<!-- Body -->
<mat-dialog-content>

    <!-- Information Table -->
    <table>

        <!-- Course Name -->
        <tr>
            <td translate>Course Name</td>
            <td>{{course ? course : ''}}</td>
        </tr>

        <!-- Course-Section -->
        <tr>
            <td translate>Course-Section</td>
            <td>{{courseSection ? courseSection : ''}}</td>
        </tr>

        <!-- Teacher -->
        <tr>
            <td translate>Teacher</td>
            <td>{{teacherName ? teacherName : ''}}</td>
        </tr>

        <!-- School -->
        <tr>
            <td translate>School</td>
            <td>{{schoolName ? schoolName : ''}}</td>
        </tr>

        <!-- Curriculum -->
        <tr>
            <td translate>Curriculum</td>
            <td>
                <tyl-quill-text-only *ngIf="curriculum"
                    [padding]="0"
                    [html]="curriculum"></tyl-quill-text-only>
            </td>
        </tr>

        <!-- Description -->
        <tr>
            <td translate>Description</td>
            <td>
                <tyl-quill-text-only *ngIf="description"
                    [padding]="0"
                    [html]="description"></tyl-quill-text-only>
            </td>
        </tr>
    </table>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="close()"></tyl-button>
    </div>
</mat-dialog-actions>
